import { render, staticRenderFns } from "./MasterSources.vue?vue&type=template&id=84d7fd06&"
import script from "./MasterSources.vue?vue&type=script&lang=ts&"
export * from "./MasterSources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports